import type { UrgencySignalsProps } from '@eventbrite/urgency-signals';
import {
    OnlyWhenUrgencySignalsEnabled,
    UrgencyMessages,
    UrgencySignalsProvider,
} from '@eventbrite/urgency-signals';
import React, { FunctionComponent } from 'react';

import classNames from 'classnames';
import styles from './UrgencySignalsNode.module.scss';

export const UrgencySignalsNode: FunctionComponent<{
    urgencySignals: UrgencySignalsProps;
    floating?: boolean;
}> = ({ urgencySignals, floating }) => (
    <div
        className={classNames({ [styles.floating]: floating })}
        data-testid="checkout-urgency-signal"
    >
        <UrgencySignalsProvider urgencySignals={urgencySignals}>
            <OnlyWhenUrgencySignalsEnabled>
                <UrgencyMessages className={styles.urgencyMessages} />
            </OnlyWhenUrgencySignalsEnabled>
        </UrgencySignalsProvider>
    </div>
);
